import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';

import EmissionValueWithSuffix from '../../../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { EmissionSymbol } from '../../../../../../../../../../../../../../shared/interfaces/IFootprint';
import { IInputMaterial } from '../../../../../../PcfWizard.type';
import RemoveButton from '../../../../RemoveButton';
import styles from './SelectedInputMaterialDetail.module.css';

interface SelectedInputMaterialDetailProps {
  inputMaterial: IInputMaterial;
  onRemoveInputMaterial: () => void;
}

const SelectedInputMaterialDetail = ({
  inputMaterial,
  onRemoveInputMaterial,
}: SelectedInputMaterialDetailProps) => {
  return (
    <div className='flex flex-row justify-content-between gap-3'>
      <div className='flex flex-column'>
        {inputMaterial?.product_cid && (
          <Tag rounded className={classNames('font-medium w-fit', styles['component-id-tag'])}>
            {inputMaterial?.product_cid}
          </Tag>
        )}
        <span className='text-2xl font-medium mb-0'>{inputMaterial?.material_name}</span>
        <RemoveButton
          onClick={() => {
            onRemoveInputMaterial();
          }}
        />
      </div>
      <div className='flex flex-column min-h-max min-w-max justify-content-center'>
        <EmissionValueWithSuffix
          emissionValue={inputMaterial?.pcf_excluding_biogenic}
          declaredUnit={inputMaterial?.declared_unit}
          unitaryProductAmount={inputMaterial?.unitary_product_amount}
          emissionSymbol={EmissionSymbol.KG_CO2E}
          abbreviateUnit={true}
          emissionValueDecimals={6}
          numericalValueTextClassName='text-2xl font-bold'
          suffixTextClassName='text-gray-900'
        />
      </div>
    </div>
  );
};

export default SelectedInputMaterialDetail;
